import Vue from "vue"
import Router from "vue-router"
import store from "@/store/index.js"
import routes from "@/router/routes/index.js"

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: "*",
      redirect: "/404"
    },
    {
      path: "/",
      // Pengunjung yang belum login diarahkan ke dashboard publik (bukan kena
      // bounce ke /login lagi). Admin yang sudah login tetap ke dashboard internal
      // seperti biasa. Pakai function biar dicek ulang tiap kali "/" diakses,
      // bukan redirect statis (menghindari redirect loop dengan meta.onlyLoggedOut
      // di route /dashboard-public).
      redirect: () => (store.state.authenticated ? "/dashboard" : "/dashboard-public")
    }
  ].concat(routes)
})

// -- SEO: update <title> + meta tags tiap pindah halaman --
// Route yang tidak set meta.description/meta.robots secara eksplisit (mayoritas
// halaman admin) otomatis default ke noindex, karena memang tidak ada gunanya
// diindeks mesin pencari (perlu login, tidak ada konten publik).
function setMetaTag(attr, key, content) {
  if (!content) return
  let el = document.querySelector(`meta[${attr}="${key}"]`)
  if (!el) {
    el = document.createElement('meta')
    el.setAttribute(attr, key)
    document.head.appendChild(el)
  }
  el.setAttribute('content', content)
}

function setCanonical(href) {
  let el = document.querySelector('link[rel="canonical"]')
  if (!el) {
    el = document.createElement('link')
    el.setAttribute('rel', 'canonical')
    document.head.appendChild(el)
  }
  el.setAttribute('href', href)
}

router.beforeEach((to, from, next) => {
  const authenticated = store.state.authenticated
  const isAll = to.matched.some(record => record.meta.all)
  const onlyLoggedOut = to.matched.some(record => record.meta.onlyLoggedOut)
  const isPublic = to.matched.some(record => record.meta.public)
  
  if (!isAll && !isPublic && !authenticated) {
    return next({
      path: "/login"
    })
  }
  if (authenticated && onlyLoggedOut) {
    return next("/")
  }

  const pageTitle = `${to.meta.title} | SIMPELBANG`
  document.title = pageTitle

  setMetaTag('name', 'description', to.meta.description)
  setMetaTag('name', 'robots', to.meta.robots || 'noindex, nofollow')
  setMetaTag('property', 'og:title', pageTitle)
  setMetaTag('property', 'og:description', to.meta.description)
  setMetaTag('property', 'og:url', window.location.origin + to.fullPath)
  setMetaTag('name', 'twitter:title', pageTitle)
  setMetaTag('name', 'twitter:description', to.meta.description)
  setCanonical(window.location.origin + to.fullPath)

  next()
})

export default router